import React from "react";
import { makeStyles } from "@fluentui/react-components";

const useStyles = makeStyles({
  root: {
    position: "absolute",
    inset: 0,
    backgroundColor: "var(--xr-participant-stage-background)",
    pointerEvents: "none"
  }
});

export function ParticipantBackdrop() {
  const styles = useStyles();

  return <div className={styles.root} aria-hidden="true" data-participant-backdrop="" />;
}
